// We use EventListener for changing Credentials. Otherwise we check if they don't expire.
const CREDENTIALS_EXPIRATION = "tasks_credentials_expiration";
const CREDENTIALS_VALUE = "tasks_credentials_value";

// 72 Hours for expiration
const EXPIRATION = 72 * 60 * 60 * 1000;
const PREFFIX = "A4n";

function extendExpiration(){
  const date = new Date();
        date.setTime(date.getTime() + EXPIRATION);

  localStorage.setItem(CREDENTIALS_EXPIRATION, date.toGMTString());
}


export function getCredentials() {
  try {
    const expiration = new Date(localStorage.getItem(CREDENTIALS_EXPIRATION));
    const date = new Date();

    if (expiration != undefined && date > expiration) {
      localStorage.removeItem(CREDENTIALS_VALUE)
      throw "Expired session";
    } else {
      const value = localStorage.getItem(CREDENTIALS_VALUE);
      return JSON.parse(b64DecodeUnicode(value.substr(PREFFIX.length)));
    }
  } catch (e) {
      return null
  }
}

export function initPort(app) {
  app.ports.putCredentials && app.ports.putCredentials.subscribe(putCredentials);

  window.addEventListener('storage', () => {
    app.ports.changeCredentials && app.ports.changeCredentials.send(getCredentials());
  }, false);

  // Extend 1s before expiration
  setInterval(() => {
    extendExpiration()
  }, EXPIRATION - 1000);

  function putCredentials(x){
    extendExpiration()

    localStorage.setItem(CREDENTIALS_VALUE, PREFFIX  + b64EncodeUnicode(JSON.stringify(x)));
      app.ports.changeCredentials && app.ports.changeCredentials.send(x);
  }
}


// Credit: https://stackoverflow.com/questions/30106476/using-javascripts-atob-to-decode-base64-doesnt-properly-decode-utf-8-strings

function b64EncodeUnicode(str) {
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function(match, p1) {
    return String.fromCharCode(parseInt(p1, 16))
  }))
}

function b64DecodeUnicode(str) {
  return decodeURIComponent(Array.prototype.map.call(atob(str), function(c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
  }).join(''))
}